module.exports = __webpack_public_path__ + "img/photo_lector@2x.b6ce9f97.png";